module.exports = __webpack_public_path__ + "img/fanhui.337b87c0.svg";